import {Link} from '@aboutyou/router';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {typographyStyles} from './typographyStyles';

const StyledLink = styled(Link)<{$large?: boolean}>`
  ${typographyStyles};

  font-size: ${props => (props.$large ? FONT_SIZES.px14 : FONT_SIZES.px12)};
  font-weight: ${props =>
    props.$large ? FONT_WEIGHTS.light : FONT_WEIGHTS.mediumBold};
`;

interface BreadcrumbLinkProps {
  link: {
    path: string;
    label: string;
  };
  large?: boolean;
}

export const BreadcrumbLink: FC<BreadcrumbLinkProps> = ({link, large}) => {
  return (
    <StyledLink data-testid="Link" to={link.path} $large={large}>
      {link.label}
    </StyledLink>
  );
};
